import { useEffect, useRef } from 'react';

/**
 * Returns true when the trigger prop transitions from false to true (or is true on mount),
 * so a one-time flash can be applied. Clears automatically after duration so the flash
 * does not re-run when the list is shown again (e.g. returning from detail view).
 */
export function useFlashOnArrival(trigger: boolean, durationMs = 2100): boolean {
  const shouldFlashRef = useRef(trigger);
  const prevTriggerRef = useRef(trigger);

  if (trigger && !prevTriggerRef.current) {
    shouldFlashRef.current = true;
  }
  prevTriggerRef.current = trigger;

  useEffect(() => {
    if (!shouldFlashRef.current) return;
    const id = setTimeout(() => {
      shouldFlashRef.current = false;
    }, durationMs);
    return () => clearTimeout(id);
  }, [trigger, durationMs]);

  return shouldFlashRef.current;
}
